import { useState } from "react";

type ValidatorFn<T> = (values: T) => Record<string, boolean>;

export function useFormValidation<T>(values: T, validate: ValidatorFn<T>) {
  const [touched, setTouched] = useState<Record<string, boolean>>({});

  const errors = validate(values);
  const isValid = !Object.values(errors).some(Boolean);

  const touch = (field: string) =>
    setTouched(prev => ({ ...prev, [field]: true }));

  const shouldShowError = (field: string) => touched[field] && errors[field];

  return {
    isValid,
    errors,
    touch,
    shouldShowError,
  };
}
